import { useCallback, useEffect, useState } from "react";

export function useGeolocation() {
  // maybe this state could be shared at a higher context to make page transitions smoother
  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [error, setError] = useState<GeolocationPositionError | null>(null);
  const [resetCounter, setResetCounter] = useState(0);
  const request = useCallback(() => {
    setResetCounter((i) => i + 1);
  }, []);

  useEffect(() => {
    let cancel = false;

    function position(value: GeolocationPosition) {
      if (cancel) return;

      setPosition(value);
      setError(null);
    }
    function error(value: GeolocationPositionError) {
      if (cancel) return;

      setPosition(null);
      setError(value);
    }

    navigator.geolocation.getCurrentPosition(position, error);

    const watchId = navigator.geolocation.watchPosition(position, error);

    return () => {
      navigator.geolocation.clearWatch(watchId);
      cancel = true;
    };
  }, [resetCounter]);

  return { position, error, request };
}
